import styled from 'styled-components';

const UpgradeAccountButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export { UpgradeAccountButtonsWrapper };
